import React from "react";
import { render } from "react-dom";
import App from './containers/App';
import 'react-toastify/dist/ReactToastify.css';

render(<App />, document.getElementById("root"));


//"homepage": "http://ciamac-da.github.io/ciademy",
